<form class="pagination" [formGroup]="form" (ngSubmit)="applyPage($event)">
	<button
		type="button"
		class="pagination-item pagination-item--first"
		[disabled]="previousIsDisabled"
		(click)="changePage(firstPage)"
	></button>
	<button
		type="button"
		class="pagination-item pagination-item--prev"
		[disabled]="previousIsDisabled"
		(click)="changePage(currentPage - 1)"
	></button>
	<div class="d-flex align-items-center">
		<input type="number" class="pagination-item-input" formControlName="pageNumber" (focusout)="applyPage()" />
		<div class="pagination-item-info">Out of {{ countOfPages }}</div>
	</div>
	<button
		type="button"
		class="pagination-item pagination-item--next"
		[disabled]="nextIsDisabled"
		(click)="changePage(currentPage + 1)"
	></button>
	<button
		type="button"
		class="pagination-item pagination-item--last"
		[disabled]="nextIsDisabled"
		(click)="changePage(countOfPages)"
	></button>
</form>
